export enum SubscriberPurchaseChannel {
  SUBSCRIBER_PURCHASE_CHANNEL_UNSET = 'SUBSCRIBER_PURCHASE_CHANNEL_UNSET', // Do not use, needed because of proto3 limitations
  SUBSCRIBER_PURCHASE_CHANNEL_MOBILE_APP = 'SUBSCRIBER_PURCHASE_CHANNEL_MOBILE_APP',
  SUBSCRIBER_PURCHASE_CHANNEL_CAPTIVE_PORTAL = 'SUBSCRIBER_PURCHASE_CHANNEL_CAPTIVE_PORTAL',
  SUBSCRIBER_PURCHASE_CHANNEL_OTHER = 'SUBSCRIBER_PURCHASE_CHANNEL_OTHER',
}
